export const downloadTexts = {
  de: {
    png: 'PNG herunterladen',
    jpeg: 'JPEG herunterladen',
    svg: 'SVG herunterladen',
    pdf: 'PDF herunterladen',
    openFlipbook: 'Flipbook öffnen'
  },
  en: {
    png: 'Download PNG',
    jpeg: 'Download JPEG',
    svg: 'Download SVG',
    pdf: 'Download PDF',
    openFlipbook: 'Open PDF'
  }
}
